import { PriceDisplay } from '@/components/blocks/PriceDisplay';
import { Grid, Stack, Typography } from '@mui/material';

export const PromotionDetails: React.FC<{
	plazo: string;
	pago: string;
	total: string;
	paymentDate: string;
	currency?: string;
}> = ({ plazo, pago, total, paymentDate, currency }) => (
	<Stack>
		<Stack direction={'column'}>
			<Grid container direction={'row'}>
				<Grid item md={4} xs={4} sx={{ p: '15px 20px 8px' }}>
					<Typography
						component={'span'}
						sx={{ fontSize: 'var(--font-size-small)', fontWeight: 'bold' }}
					>
						{'Plazo'}
					</Typography>
				</Grid>
				<Grid item md={4} xs={4} sx={{ p: '15px 20px 8px' }}>
					<Typography
						component={'span'}
						sx={{ fontSize: 'var(--font-size-small)', fontWeight: 'bold' }}
					>
						{'Quincenal'}
					</Typography>
				</Grid>
				<Grid item md={4} xs={4} sx={{ p: '15px 20px 8px' }}>
					<Typography
						component={'span'}
						sx={{ fontSize: 'var(--font-size-small)', fontWeight: 'bold' }}
					>
						{'Total'}
					</Typography>
				</Grid>
			</Grid>
			<Grid container direction={'row'} sx={{ backgroundColor: '#F7F7F7' }}>
				<Grid item md={4} xs={4} sx={{ p: '15px 20px 8px' }}>
					<Typography
						component={'span'}
						sx={{ fontSize: 'var(--font-size-default)', fontWeight: 'bold' }}
					>
						{plazo}
						{'	'}
						<Typography
							component={'span'}
							sx={{ fontSize: 'var(--font-size-default)', fontWeight: 'normal' }}
						>
							{'quincenas'}
						</Typography>
					</Typography>
				</Grid>
				<Grid item md={4} xs={4} sx={{ p: '15px 20px 8px' }}>
					<Typography
						component={'span'}
						sx={{ fontSize: 'var(--font-size-default)', fontWeight: 'normal' }}
					>
						<PriceDisplay currency={currency} min={+pago} />
					</Typography>
				</Grid>
				<Grid item md={4} xs={4} sx={{ p: '15px 20px 8px' }}>
					<Typography
						component={'span'}
						sx={{ fontSize: 'var(--font-size-default)', fontWeight: 'bold' }}
					>
						<PriceDisplay currency={currency} min={+total} />
					</Typography>
				</Grid>
			</Grid>
		</Stack>
		<Stack direction={'row'} mt={'15px'}>
			<Typography component={'span'} sx={{ fontSize: 'var(--font-size-small)' }}>
				{'Empiezas a pagar el: '}{' '}
				<Typography
					component={'span'}
					sx={{ fontWeight: 'bold', fontSize: 'var(--font-size-small)' }}
				>
					{paymentDate}
				</Typography>
			</Typography>
		</Stack>
	</Stack>
);
